import {useSelector} from 'react-redux';

/**
 * Whether the current user has the support role.
 * @returns {boolean}
 */
export const useIsSupport = () => useSelector(state => state.user.isSupport);
